var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1643",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 17,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.00049H20.9668V22.3561H4V2.00049Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4834 3.5C11.6354 3.5 6.28541 5.384 5.66841 5.899C5.48641 6.082 5.47941 6.4 5.51841 8.529C5.53641 9.555 5.56141 10.949 5.56141 12.879C5.56141 18.08 11.2834 20.389 12.4824 20.814C13.6804 20.387 19.4054 18.065 19.4054 12.879C19.4054 10.947 19.4304 9.552 19.4494 8.526C19.4874 6.399 19.4804 6.081 19.2874 5.889C18.6824 5.384 13.3314 3.5 12.4834 3.5ZM12.4834 22.356C12.4104 22.356 12.3374 22.346 12.2664 22.324C11.9314 22.223 4.06141 19.761 4.06141 12.879C4.06141 10.962 4.03641 9.575 4.01841 8.557C3.97241 6.014 3.96241 5.484 4.61941 4.828C5.40441 4.041 11.3494 2 12.4834 2C13.6164 2 19.5614 4.041 20.3484 4.828C21.0044 5.484 20.9944 6.014 20.9484 8.554C20.9304 9.572 20.9054 10.959 20.9054 12.879C20.9054 19.761 13.0354 22.223 12.7004 22.324C12.6294 22.346 12.5564 22.356 12.4834 22.356Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7771 14.5196C11.5781 14.5196 11.3871 14.4406 11.2461 14.2996L9.35413 12.4056C9.06213 12.1126 9.06213 11.6366 9.35513 11.3446C9.64713 11.0516 10.1231 11.0516 10.4161 11.3446L11.7771 12.7076L15.1451 9.33962C15.4381 9.04662 15.9121 9.04662 16.2051 9.33962C16.4981 9.63262 16.4981 10.1076 16.2051 10.4006L12.3071 14.2996C12.1671 14.4406 11.9761 14.5196 11.7771 14.5196Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDone);
export default __webpack_public_path__ + "static/media/ShieldDone.900b9bbb21debd13394d5177d585763f.svg";
export { ForwardRef as ReactComponent };